import { qsa } from "@fluorescent/dom";
import {
  ImageReveal,
  FadeUpReveal,
  FadeUpSplitReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  images: ".image",
  fadeUp: ".animation-fade-up-reveal",
  fadeUpSplit: ".animation-fade-up-split-reveal",
};

export default node => {
  let observer = null;
  const fadeUpSplitItems = qsa(selectors.fadeUpSplit, node);
  const fadeUpItems = qsa(selectors.fadeUp, node);
  const images = qsa(selectors.images, node);
  const textReveals = [];
  const imageReveals = [];

  if (shouldAnimate(node)) {
    fadeUpSplitItems.forEach(item => {
      textReveals.push(new FadeUpSplitReveal(item));
    });

    fadeUpItems.forEach(item => {
      textReveals.push(new FadeUpReveal(item));
    });

    images.forEach(image => {
      imageReveals.push(new ImageReveal(image));
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let textDelay = window.theme.animation.delay;
    textReveals.forEach(reveal => {
      reveal.play(textDelay);

      if (reveal.type === "FadeUpSplitReveal") {
        textDelay += reveal.lineCount * window.theme.animation.delay;
      } else {
        textDelay += window.theme.animation.delay;
      }
    });

    let imageDelay = window.theme.animation.delay;
    imageReveals.reverse().forEach((reveal, i) => {
      imageDelay = window.theme.animation.delayLong * i;
      reveal.play(imageDelay);
    });
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
